import React, { useCallback, useEffect, useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Login from "./pages/Login";
import Solicitudes from "./pages/Solicitudes";
import DetalleSolicitud from "./pages/DetalleSolicitud";
import Productores from "./pages/Productores";
import Sidebar from "./layout/Sidebar";
import TopBar from "./layout/TopBar";
import ProtectedRoute from "./components/ProtectedRoute";
import { Container } from "react-bootstrap";
import { Box } from "@material-ui/core";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";
import { authenticationService } from "./services";

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      '"Inter"',
      '"Roboto"',
      '"Helvetica"',
      '"Arial"',
      "sans-serif",
    ].join(","),
  },
});

const App = () => {
  const [loggedIn, setLoggedIn] = useState(
    authenticationService.checkSessionValidity()
  );
  
  const evaluarSesion = useCallback(() => {
    setLoggedIn(authenticationService.checkSessionValidity());
  }, []);

  useEffect(() => {
    evaluarSesion();
  }, [evaluarSesion]);

  // Agregar/quitar clase del body según el estado de login
  useEffect(() => {
    if (loggedIn) {
      document.body.classList.remove('public-layout');
    } else {
      document.body.classList.add('public-layout');
    }
  }, [loggedIn]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {loggedIn ? (
        <Box style={{ display: 'flex', minHeight: '100vh', margin: 0, padding: 0 }}>
          <Sidebar onLogout={evaluarSesion} />
          <Box
            style={{
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              minHeight: '100vh',
              margin: 0,
              padding: 0
            }}
          >
            <TopBar onLogout={evaluarSesion} />
            <Box
              component="main"
              className="main-content-logged"
              style={{
                flexGrow: 1,
                padding: '2rem',
                backgroundColor: '#f5f6fa',
              }}
            >
              <Switch>
                <Route exact path="/">
                  <Redirect to="/solicitudes" />
                </Route>
                <ProtectedRoute exact path="/solicitudes" component={Solicitudes} />
                <ProtectedRoute exact path="/solicitudes/:id" component={DetalleSolicitud} />
                <ProtectedRoute exact path="/productores" component={Productores} />
                <Route path="*">
                  <Redirect to="/solicitudes" />
                </Route>
              </Switch>
            </Box>
          </Box>
        </Box>
        ) : (
        <>
          <main className="main-content" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f6fa' }}>
            <Container>
              <Switch>
                <Route
                  exact
                  path="/login"
                  render={(routeProps) => (
                    <Login {...routeProps} onAuthChange={evaluarSesion} />
                  )}
                />
                <Route path="*">
                  <Redirect to="/login" />
                </Route>
              </Switch>
            </Container>
          </main>
        </>
      )}
    </ThemeProvider>
  );
};

export default App;
